module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('DModal', {
    staticStyle: {
      "z-index": "123123"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "placeInTop": true,
      "appendToBody": true,
      "isCloseOnEsc": !_vm.isCreateCategory && !_vm.theEditTask && !_vm.isWatchGuide
    },
    on: {
      "close": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "d-modal",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__content text-dark"
  }, [_c('div', {
    staticClass: "d-modal__content__sidebar"
  }, [_c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": _vm.onClose
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })]), _vm._v(" "), _c('h2', [_vm._v("Design opgaveoversigter")]), _vm._v(" "), _c('ul', {
    staticClass: "d-modal__content__sidebar__nav"
  }, [_c('button', {
    staticClass: "do-bttn",
    attrs: {
      "id": "do-bttn--watch-guide"
    },
    on: {
      "click": function($event) {
        _vm.isWatchGuide = true
      }
    }
  }, [_vm._v("Se guide")]), _vm._v(" "), _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      staticClass: "d-modal__content__sidebar__nav-item",
      class: {
        'd-modal__content__sidebar__nav-item--active': tab.id === _vm.theActiveTab
      },
      on: {
        "click": function($event) {
          return _vm.setTheActiveTab(tab.id)
        }
      }
    }, [_vm._v("\n            " + _vm._s(tab.title) + "\n          ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content__body"
  }, [(_vm.isInitLoading) ? _c('Loader', {
    attrs: {
      "bgColor": "#fff"
    }
  }) : [(_vm.theActiveTab === 1) ? _c('TaskOverviewSettingsCategories', {
    attrs: {
      "schoolId": _vm.schoolId,
      "schoolYearId": _vm.schoolYearId,
      "schoolYear": _vm.schoolYear,
      "locale": _vm.locale,
      "taskCategories": _vm.taskCategories,
      "dbSubjectTypes": _vm.dbSubjectTypes,
      "subjects": _vm.subjects
    },
    on: {
      "onDeleteTaskCategory": _vm.onDeleteTaskCategory,
      "updateCategory": _vm.onUpdateCategory,
      "setCreateCategory": _vm.setCreateCategory,
      "onSetEditTask": _vm.onSetEditTask
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 2) ? _c('TaskOverviewSettingsCategoriesTasks', {
    attrs: {
      "taskCategories": _vm.taskCategoriesSorted,
      "schoolId": _vm.schoolId,
      "schoolYearId": _vm.schoolYearId,
      "subjects": _vm.subjects,
      "allCalendarsInHash": _vm.allCalendarsInHash,
      "allUsersInHash": _vm.allUsersInHash,
      "tags": _vm.tags
    },
    on: {
      "setCreateCategory": _vm.setCreateCategory,
      "updateSubjects": _vm.updateSubjects
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 3) ? _c('TaskOverviewSettingsSettings', {
    attrs: {
      "taskCategories": _vm.taskCategories
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theActiveTab === 4) ? _c('TaskOverviewSettingsUserTasks', {
    attrs: {
      "theActiveUserId": _vm.theActiveUserIdForExample,
      "users": _vm.users,
      "schoolYear": _vm.schoolYear
    },
    on: {
      "setTheActiveUserId": _vm.setTheActiveUserIdForExample
    }
  }) : _vm._e()]], 2), _vm._v(" "), (_vm.isCreateCategory) ? _c('TaskOverviewSettingsCategoryCreate', {
    attrs: {
      "schoolId": _vm.schoolId,
      "schoolYearId": _vm.schoolYearId,
      "taskCategories": _vm.taskCategories
    },
    on: {
      "close": function($event) {
        _vm.isCreateCategory = false
      },
      "onNewCategory": _vm.onNewCategory
    }
  }) : _vm._e()], 1)])]), (_vm.isWatchGuide) ? _c('DModal', {
    staticStyle: {
      "z-index": "12312323"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "placeInTop": true,
      "appendToBody": true,
      "isCloseOnEsc": !_vm.isCreateCategory && !_vm.theEditTask
    },
    on: {
      "close": function($event) {
        _vm.isWatchGuide = false
      }
    }
  }, [_c('div', {
    staticClass: "d-modal d-modal--guide",
    staticStyle: {
      "width": "90vw"
    },
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": function($event) {
        _vm.isWatchGuide = false
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content__guide text-dark"
  }, [_c('TaskOverviewSettingsGuide')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5b9f97b0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TaskOverviewSettings/TaskOverviewSettings.vue
// module id = 1599
// module chunks = 1